var Spinner = require("components/utility/Spinner");

require("utility/loading_button.scss");

class LoadingButton extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onClick(e) {
		if (this.props.onClick && !this.props.loading && !this.props.enabledButton) {
			this.props.onClick(e);
		}
	}
 
	render() {
		var className, textStyle;

		if (this.props.loading) {
			textStyle = { left: "800px" };
			className = "loadingButton disabledButton";
			var spinner = (<Spinner center={ true } ops={{ color: "#fff" }} />);

		} else if (this.props.disabled) {
			textStyle = { left: "0px" };
			className = "loadingButton disabledButton";

		} else {
			textStyle = { left: "0px" };
			className = "loadingButton enabledButton";
		}

		if (this.props.className) {
			className += " " + this.props.className;
		}

		// Omit props for the component only:
		var buttonProps = _.omit(this.props, "text", "loading", "onClick");

		return (
			<button { ...buttonProps } onClick={ this.onClick } className={ className } >
				{ spinner }
				<span className="text" style={ textStyle }>{ this.props.text }</span>
			</button>
		);
	}
};

LoadingButton.propTypes = StrictPropTypes({
	// Text to show on button (when not loading)
	text: PropTypes.string.isRequired,

	// If true, text is hidden, spinner is shown
	loading: PropTypes.bool,

	// If true, disables button
	disabled: PropTypes.bool,

	// Extra className to apply to button tag
	className: PropTypes.string,

	value: PropTypes.string,

	// Function to call after button is clicked
	onClick: PropTypes.func,

	// Props pass on to the button
	"data-tip": PropTypes.string,

	type: PropTypes.string
});

module.exports = LoadingButton;




// WEBPACK FOOTER //
// ./modules/components/utility/LoadingButton.js